import { createFileRoute } from '@tanstack/react-router';

import { PresentationVariablesPage } from '../features/presentations/presentation-authoring-pages';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables',
)({ component: RouteComponent });

function RouteComponent() {
  const params = Route.useParams();
  return <PresentationVariablesPage {...params} />;
}
